import React, { Fragment } from 'react'
import {
    List, Datagrid, Filter, ShowButton, UrlField, TextInput, DateInput, Button, TextField, EditButton, useListContext, FunctionField, DeleteButton, useRecordContext, Link
} from 'react-admin'
import { InfluencerStatusSelectInput, InfluencerRatingBasedSelectInput, AdminUserSelectInput } from '../../UI/Input/SelectInput'

import { DateRangeInput } from '../../UI/Input/input';
import useCheckPermissions from '../AdminPermissions/useCheckPermissions'

const ListFilter = (props) => {
    const {

        setFilters,
        hideFilter
    } = useListContext();
    return (

        <Filter {...props}>
            <TextInput label="Search" source="q" alwaysOn />
         
            {/* <DateRangeInput alwaysOn onClear={() => { hideFilter('daterange') }} onChange={(strdate) => {
                setFilters({ daterange: strdate })
            }} /> */}
        </Filter>
    )
};

const ProfileidFiled = (props) => {
    const record = useRecordContext();
    return (
        <TextField {...props} component={Link} to={`/user?filter={"q":"${record.profile_id}"}`} onClick={(event) => event.stopPropagation()} />
    )
}


const MediaBoosterList = ({ ...props }) => {

    return (
        <List {...props} title="Influencer" filters={<ListFilter />} filter={{ uid: -1 }} sort={{ field: 'title', order: 'ASC' }}>

            <Datagrid >
                <ProfileidFiled source="profile_id" label="Profile Id" />
                <TextField source='name' label="name" />
                <FunctionField source="watched_video_url" label="Link" render={record => {
                    return (<Button target="_blank" style={{ color: 'green', border: '1px solid' }} href={record.watched_video_url} label="Link" size="small"></Button>)

                }} />
                <TextField source="amount" label="Amount" />
                <TextField source='created_at' label="Created At" />
            </Datagrid>

        </List>
    )
}


export default MediaBoosterList